<template>
	<Products
		:products="products"
		:show-terms="props.showTerms"
		:active="activeProduct"
		:theme="productsTheme"
		:product-component="productComponent"
		@select="setActiveProduct"
	/>
</template>

<script setup>
import { ref } from '@vue/reactivity'
import { watch } from '@vue/runtime-core'

import Products from './Products'

// eslint-disable-next-line no-undef
const emit = defineEmits(['change'])
// eslint-disable-next-line no-undef
const props = defineProps({
	products: {
		type: Array,
		required: true,
		default: () => []
	},
	showTerms: { type: Boolean, default: true },
	productsTheme: { type: String, default: '' },
	productComponent: { type: String, default: 'Product' }
})

const activeProduct = ref(null)
const setActiveProduct = (product) => {
	activeProduct.value = product
	emit('change', product)
}

watch(
	() => props.products,
	() => {
		setActiveProduct(props.products.find((product) => product.preset))
	},
	{
		immediate: true
	}
)
</script>
